export const totalRunningTimeDoughnutColorList = ['midBlue', 'gold', 'lightBlue', 'lightPink', 'green'];
